import React, { forwardRef, useMemo } from 'react';
import { cx } from 'linaria';
import { Typography } from 'fronton-react';
import { content } from './styles';
import { DrawerContentProps } from './types';

/**
 * `<DrawerContent>` - Обёртка для контента Drawer.
 * Предоставляет стили для контента.
 */
export const DrawerContent = forwardRef<HTMLDivElement, DrawerContentProps>(
  ({ children, className, ...props }, ref) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const testId = props['data-testid'] || 'drawer-content';
    const contentClassName = useMemo(() => cx(content, className), [className]);

    return (
      <Typography
        variant="m"
        size="body_long"
        {...props}
        color="text-primary"
        className={contentClassName}
        ref={ref}
        data-testid={testId}
      >
        {children}
      </Typography>
    );
  },
);
